export default __webpack_public_path__ + "static/media/money_and_coins_white.3a8b9cb7.png";